<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>
import Vue from "vue";
import { FadeTransition } from "vue2-transitions";

/**
 * 步驟一：處理舊的 Hash 模式路徑重定向
 */
const current_hash = window.location.hash

if (current_hash && current_hash.startsWith('#/')) {
  // 1. 取得 Hash 內的路徑部分，例如從 '#/about' 變成 '/about'
  const hash_path = current_hash.slice(1) 
  
  // 2. 取得當前的路徑名稱 (Pathname)，這會包含子目錄
  //    - 根目錄部署: window.location.pathname = '/'
  //    - 子目錄部署: window.location.pathname = '/my-app/'
  let current_path = window.location.pathname 

  // 確保 currentPath 結尾是 '/'，這樣後面串接才正確
  if (!current_path.endsWith('/')) {
    current_path += '/'
  }

  // 3. 組合新的 History 模式 URL
  //    - 根目錄: '/' + '/about'  => '/about'
  //    - 子目錄: '/my-app/' + '/about' => '/my-app/about'
  const new_history_path = current_path + hash_path.substring(1) // 再次去除 hashPath 開頭的 /

  // 4. 替換 URL
  window.history.replaceState(null, '', new_history_path) 

  console.log(`[Hash 重定向] 舊 Hash: ${current_hash}，已重定向至 History 模式: ${new_history_path}`)
}


/**
 * 步驟二：正常啟動 Vue 應用程式
 */
var vm = new Vue({
  el: 'window',  
  mounted() {
  	window.addEventListener('scroll', this.handleScroll);
  },
  data: {
  	navbarFixed: false
  },
  methods: {
    handleScroll() {
	    let navbar = document.querySelector('#navbar');
      let scroll_top = window.PageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	    let offset_top = navbar.offsetTop;
	  
	    if (scroll_top > offset_top) {
	  	  navbar.classList.add('navbar-fixed');
	    } else {
	      navbar.classList.remove('navbar-fixed');
	    };

	    this.navbarFixed = scroll_top > offset_top;
    }
  }
});

export default {
  components: {
    FadeTransition
  },
  metaInfo: {
    title: '載入中...',
    titleTemplate: '%s | 財團法人佛陀教育基金會',
    meta: [{
      vmid: 'description',
      name: 'description',
      content: '財團法人佛陀教育基金會致力於佛陀教育的推廣與弘揚。'
    }]
  }
};
</script>
